<template>
  <main-content>
    <kt-panel>
      <kt-panel-header>
        <kt-panel-header-toolbar>
          <ul class="nav nav-pills" role="tablist">
            <li class="nav-item">
              <a :class="['nav-link', currentTab === 1 ? 'active' : '']" href="#gateway-info" @click="gotoTab(1)">
                {{ $t('label.gateway-info') }}
              </a>
            </li>
            <li class="nav-item">
              <a :class="['nav-link', currentTab === 2 ? 'active' : '']" href="#terminals" @click="gotoTab(2)">
                {{ $t('label.terminals') }}
              </a>
            </li>
            <!--                    <li class="nav-item">-->
            <!--                        <a :class="['nav-link', currentTab === 3 ? 'active' : '']" href="#tax-info" @click="gotoTab(3)">-->
            <!--                            {{ $t('label.tax-info') }}-->
            <!--                        </a>-->
            <!--                    </li>-->



            <li class="nav-item">
              <a :class="['nav-link', currentTab === 4 ? 'active' : '']" href="#switching-settings" @click="gotoTab(4)">
                {{ $t('label.switching_setting') }}
              </a>
            </li>
          </ul>
        </kt-panel-header-toolbar>
      </kt-panel-header>
      <kt-panel-body>
        <div class="tab-content">
          <div :class="['tab-pane', currentTab === 1 ? 'active' : '']" id="#gateway_info">
            <kt-row>
              <kt-col xs="12" md="6">
                <gateway-info :form_data="form_data" :submit="submit"  v-if="status === 'setFormData'"></gateway-info>
              </kt-col>
              <kt-col xs="12" md="6" v-if="status !== 'loading'">
                <div v-if="status === 'setFormData'">
                  <router-link v-if="form_data.status === gatewayStatuses.DIRECT_TO_PSP"
                               class="btn btn-secondary border-0 w-100 bg-secondary text-dark btn-square mt-2 mb-2"
                               :to="'/gateways/transactions-report/' + form_data.id"
                  >
                    {{ $t('btn.getTransactionReport') }}
                  </router-link>
                </div>
                <div v-if="form_data.status === gatewayStatus.PENDING">
                  <gateway-setting></gateway-setting>
                </div>
                <div v-else>
                  <gateway-statistics></gateway-statistics>
                  <gateway-setting></gateway-setting>
                  <settlement-settings></settlement-settings>
                </div>
              </kt-col>
            </kt-row>
          </div>
          <div :class="['tab-pane', currentTab === 2 ? 'active' : '']">
            <terminals :psp_list="form_data.terminals"
                       v-if="status === 'setFormData' && shop_psp_requests_status === 'success'">
            </terminals>
          </div>
          <!--                <div :class="['tab-pane', currentTab === 3 ? 'active' : '']" id="tax-info">-->
          <!--                    <tax-info></tax-info>-->
          <!--                </div>-->
          <div :class="['tab-pane', currentTab === 4 ? 'active' : '']">
            <switching-setting :shop_type="0" :is_dedicated="this.form_data.shop_type == 2" v-if="status === 'setFormData'"></switching-setting>
          </div>
        </div>
      </kt-panel-body>
    </kt-panel>
  </main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import { mapGetters } from 'vuex'
import { KTApp } from '@/plugins/core/app'
import { KTUtil } from '@/plugins/core/util'
import { gatewayService } from '@/common/api.service'
import { gatewaySetting, gatewayInfo, taxInfo, settlementSettings, terminals } from './components'
import gatewayStatistics from './components/gateway-statistics'
import $ from 'jquery'
import switchingSetting from '../collective/components/switching-settings'
import {gatewayStatus} from "@/constants/gatewayStatus";

export default {
  components: {
    mainContent,
    gatewaySetting,
    gatewayInfo,
    // taxInfo,
    switchingSetting,
    settlementSettings,
    terminals,
    'gateway-statistics': gatewayStatistics
  },
  computed: {
    ...mapGetters('gateway', [
      'form_data', 'status'
    ]),
    ...mapGetters('address', [
      'addresses'
    ]),
    ...mapGetters('shebaNumber', [
      'iban_list'
    ]),
    ...mapGetters('pspRequest', [
      'shop_psp_requests_status',
      'current_psp_tab',
    ]),
  },
  data() {
    return {
      gatewayStatus,
      gatewayStatuses: gatewayStatus,
      currentTab: 1,
      'hashid': this.$route.params.hashid,
      is_starshop: this.$route.params.gateway_source === 'starshop-gateways',
    }
  },
    beforeRouteEnter (to, from, next) {
        const is_starshop = to.params.gateway_source === 'starshop-gateways';
        next(vm => {
          let is_admin = vm.$can('read', 'ipg-gateway')
          vm.$store.dispatch('gateway/find', { hashid: vm.hashid, is_admin: is_admin, is_starshop : is_starshop });
        });
    },
  methods: {
    gotoTab(selectedTab) {
      this.currentTab = selectedTab;
      window.localStorage.setItem('gateway_details_active_tab', selectedTab);
    },
    submit(e) {
      let form = $('#gateway_form')
      let btn = $('#submit_btn')

      KTApp.progress(btn)

      let params = this.$store.getters['gateway/form_data']
      gatewayService.updateAdmin(this.hashid, params, this.is_starshop).then(response => {
        this.showMsg(form, 'success', response.data.message)
      })
          .catch(({response}) => {
            if (response.data) {
              form.validate().showErrors(response.data.data)
            }
            this.showMsg(form, 'danger', response.data.message)
          })
          .finally(() => {
            KTUtil.scrollTop()
            KTApp.unprogress(btn)
          })
    },
  },
  mounted() {
    if (window.localStorage.getItem('secondPreviousRoutePath') === this.$router.history.current.path) {
      let tab = window.localStorage.getItem('gateway_details_active_tab');
      this.currentTab = (tab != null && tab != undefined) ? parseInt(tab) : 1;
    }
        this.$store.dispatch('shebaNumber/fetchList', {
            params: {
                'hashid': this.hashid,
                'shop_type': 0
            },
            is_starshop: this.is_starshop
        })
            .finally(() => {
                Object.keys(this.iban_list).map(key => {
                    let number = this.iban_list[key]['number'] == null ? '' : 'IR'+this.iban_list[key]['number'].split('-').join('')
                    this.iban_list[key]['number'] = number
                })
            })
        this.$store.dispatch('address/fetchByShopId', {
            params: {
                'hashid': this.hashid,
                'shop_type': 0
            },
            is_starshop: this.is_starshop
        })
        this.$store.dispatch('pspRequest/fetchByShopId', {hashid: this.hashid, is_starshop: this.is_starshop})
        this.$store.dispatch('shaparak/fetchShopShaparakRequests',{hashid: this.hashid, is_starshop: this.is_starshop})
    
    this.$store.dispatch('shebaNumber/fetchByShopId', {
        params: {
            'hashid': this.hashid,
            'shop_type': 0
        },
        is_starshop: this.is_starshop
    })
        .finally(() => {
          Object.keys(this.sheba_numbers).map(key => {
            let number = this.sheba_numbers[key]['number'] == null ? '' : 'IR'+this.sheba_numbers[key]['number'].split('-').join('')
            this.sheba_numbers[key]['number'] = number
          })
        })
      this.$store.dispatch('address/fetchByShopId', {
          params: {
              'hashid': this.hashid,
              'shop_type': 0
          },
          is_starshop: this.is_starshop
      })
    this.$store.dispatch('pspRequest/fetchByShopId', {hashid: this.hashid, is_starshop: this.is_starshop})
    this.$store.dispatch('shaparak/fetchShopShaparakRequests',{hashid: this.hashid, is_starshop: this.is_starshop})
  }
}
</script>

<style>
@media (min-width: 768px) {
  #gateway_info > div > :first-child {
    border-left: 1px solid #ddd;
  }
}
</style>